<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-list">
    <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-8">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Device</label>
          <v-select
            :disabled="select_all"
            :options="deviceList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="filter.device"
            @search="searchDevice"
            class="mb-4 md:mb-0"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Date Filter</label>
          <v-select
            :options="dateList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="filter.dateOption"
            class="mb-2 md:mb-0"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-2">
          <label class="vs-input--label">Start Time</label>
          <flat-pickr
            :disabled="disableDate"
            :config="{
              enableTime: true,
              dateFormat: 'Y-m-d H:i',
              maxDate: maxDate,
              time_24hr: true,
              defaultHour: 0
            }"
            style="width: 100%"
            v-model="filter.start_time"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-2">
          <label class="vs-input--label">End Time</label>
          <flat-pickr
            :disabled="disableDate"
            :config="{
              enableTime: true,
              dateFormat: 'Y-m-d H:i',
              maxDate: maxDate,
              time_24hr: true,
              defaultHour: 23,
              defaultMinimalute: 59
            }"
            style="width: 100%"
            v-model="filter.end_time"
          />
        </div>
        <!-- <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-2">
          <label class="text-sm opacity-75">Show Filter</label>
          <v-select
            :options="showList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="filter.showOption"
            class="mb-2 md:mb-0"
          />
        </div> -->
        <div
          v-if="enableShow == 'min_time'"
          class="vx-col md:w-1/4 sm:w-1/2 w-full mb-2"
        >
          <vs-input
            type="number"
            min="0"
            label="Minimal Time (Minute)"
            class="w-full"
            v-model="filter.min_time"
          />
        </div>
        <div
          v-if="enableShow == 'min_mileage'"
          class="vx-col md:w-1/4 sm:w-1/2 w-full mb-2"
        >
          <vs-input
            type="number"
            min="0"
            label="Minimal Mileage (Km)"
            class="w-full"
            v-model="filter.min_mileage"
          />
        </div>

        <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-2">
          <label class="text-sm opacity-75">Dealer Status</label>
          <v-select
            :options="list_dealer"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="dealer"
          />
        </div>

        <div
          v-if="actor.privilege >= 4"
          class="vx-col md:w-1/4 sm:w-1/2 w-full"
        >
          <label class="text-sm opacity-75">&nbsp;</label>
          <vs-checkbox v-model="select_all">
            <label for="">Select All Vehicle</label>
          </vs-checkbox>
        </div>

        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <vs-button
            :disabled="loading"
            id="searchBtn"
            style="width: 100%"
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-search"
            class="pl-5 mt-1 vs-con-loading__container"
            @click="search"
            >Search</vs-button
          >
        </div>
      </div>
    </vx-card>

    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <div class="flex-grow">
          <!-- <vs-button
            v-if="data.length > 0"
            id="exportBtn"
            icon-pack="feather"
            icon="icon-file-text"
            color="success"
            type="border"
            class="mb-4 md:mb-0 vs-con-loading__container"
            @click="exportReport"
            >Export</vs-button
          > -->

          <vs-button
            v-if="data.length > 0"
            id="exportBtn"
            icon-pack="feather"
            icon="icon-file-text"
            color="success"
            type="gradient"
            class="mb-4 md:mb-0 vs-con-loading__container"
            @click="handleDownload"
            >Export Data</vs-button
          >
        </div>

        <vs-dropdown vs-trigger-click class="cursor-pointer mr-2">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ page * per_page - (per_page - 1) }} -
              {{
                row_total - page * per_page > 0 ? page * per_page : row_total
              }}
              of {{ row_total }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="updatePerPage(10)">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(25)">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(50)">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(100)">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <div class="table-container">
        <el-table
          :data="data"
          :sort-by="sort_by"
          border
          style="width: 100%; margin-top: 10px; margin-bottom: 10px"
        >
          <el-table-column
            label="No"
            width="60"
            type="index"
            :index="indexMethod"
          >
          </el-table-column>
          <el-table-column prop="plate" label="Plate" sortable width="90">
          </el-table-column>
          <el-table-column
            prop="engine_on"
            label="Engine On"
            sortable
            width="130"
          >
          </el-table-column>
          <el-table-column
            prop="engine_off"
            label="Engine Off"
            sortable
            width="130"
          >
          </el-table-column>
          <el-table-column prop="hour" label="Hours" sortable width="120">
          </el-table-column>
          <el-table-column
            prop="dealer_status"
            label="Dealer Status"
            sortable
            width="80"
          >
          </el-table-column>
          <el-table-column
            prop="test_date"
            label="Test Date"
            sortable
            width="120"
          ></el-table-column>
          <el-table-column
            prop="drive_mileage"
            label="Drive Mileage"
            sortable
            width="100"
          ></el-table-column>
          <el-table-column label="Start Address" prop="start_address" sortable>
            <template slot-scope="scope">
              <div
                v-if="!scope.row.start_address && scope.row.engine_on != null"
                class="flex"
              >
                <vs-button
                  style="font-size: 14px"
                  type="border"
                  size="small"
                  color="success"
                  class="mr-2 vs-con-loading__container"
                  @click="getAddress2(scope.row, scope.$index, 'start_address')"
                >
                  Show Address
                </vs-button>
              </div>
              <div v-else>
                <vx-tooltip title="Show Street View">
                  <a
                    @click="
                      streetView(scope.row.start_lat, scope.row.start_lon)
                    "
                    style="color: #626262; cursor: pointer"
                    >{{ scope.row.start_address }}</a
                  >
                </vx-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="end_address" label="End Address" sortable>
            <template slot-scope="scope">
              <div
                v-if="!scope.row.end_address && scope.row.engine_on != null"
                class="flex"
              >
                <vs-button
                  style="font-size: 14px"
                  type="border"
                  size="small"
                  color="success"
                  class="mr-2 vs-con-loading__container"
                  @click="getAddress2(scope.row, scope.$index, 'end_address')"
                >
                  Show Address
                </vs-button>
              </div>
              <div v-else>
                <vx-tooltip title="Show Street View">
                  <a
                    @click="streetView(scope.row.end_lat, scope.row.end_lon)"
                    style="color: #626262; cursor: pointer"
                    >{{ scope.row.end_address }}</a
                  >
                </vx-tooltip>
              </div>
            </template>
          </el-table-column>

          <div
            slot="append"
            v-if="data.length < 1 || loading"
            class="table_empty"
          >
            {{ loading ? 'Loading....' : 'No Data Available' }}
          </div>
        </el-table>
        <vs-pagination :total="n_page" v-model="page" goto></vs-pagination>
      </div>
    </div>
  </div>
</template>

<style>
[dir='ltr'] .el-table .cell {
  padding-left: 10px;
  padding-right: 10px;
}

.el-table thead {
  color: #ffff;
  font-weight: bold;
}

[dir] .el-table--border::after,
[dir] .el-table--group::after,
[dir] .el-table::before {
  background-color: #ccc;
}

[dir] .el-table th.el-table__cell {
  background-color: #eee;
  font-size: 14px;
  color: #626262;
}

[dir] .el-table tr:active .el-table__cell {
  background-color: rgb(198, 198, 198);
}

[dir] .el-table td.el-table__cell,
[dir] .el-table th.el-table__cell.is-leaf {
  border-bottom: 1px solid #ccc;
}

[dir] .el-table .ascending .sort-caret.ascending {
  border-bottom-color: #ffff;
}

[dir] .el-table .descending .sort-caret.descending {
  border-top-color: #ffff;
}

.el-table--border .el-table__cell,
[dir='ltr']
  .el-table__body-wrapper
  .el-table--border.is-scrolling-left
  ~ .el-table__fixed {
  border-left: 1px solid #ccc;
  border-top: 1px solid #ccc;
}

[dir] .el-table .el-table__cell {
  padding: 7px 0;
}

.el-table__empty-block {
  display: none !important;
}

.table_empty {
  text-align: center;
  font-size: 13px;
  padding: 10px;
  border-left: 1px solid #ccc;
}

.table_total {
  padding: 10px;
  border-left: 1px solid #ccc;
}
</style>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
import FileDownload from 'js-file-download'

export default {
  components: {
    flatPickr,
    vSelect
  },

  data() {
    return {
      data: [],
      token: '',
      action: '',
      loading: false,
      actor: '',
      tempId: 0,
      disableDate: true,

      filter: {
        device: '',
        start_time: null,
        end_time: null,
        today: '',
        dateOption: { value: '', label: '-- Select Filter --' },
        min_time: null,
        min_mileage: 0,
        showOption: { value: 'min_time', label: 'Time' }
      },

      filtered: {
        device: '',
        start_time: null,
        end_time: null,
        today: '',
        dateOption: { value: '', label: '-- Select Filter --' },
        min_time: null,
        min_mileage: 0,
        showOption: { value: 'min_time', label: 'Time' }
      },

      deviceList: [],
      dateList: [
        { value: '', label: '-- Select Filter --' },
        // { value: 'today', label: 'Today' },
        { value: 'yesterday', label: 'Yesterday' },
        { value: 'define', label: 'Select Date' }
      ],

      showList: [
        // { value: 'min_time', label: 'Time' },
        { value: 'min_mileage', label: 'Mileage' }
      ],

      enableShow: 'min_mileage',

      page: 1,
      per_page: 10,
      row_total: 0,
      keyword: '',

      timer: null,
      notify: 'Server Error',
      today: '',
      yesterday: '',
      twoDaysAgo: '',

      maxDate: '',

      list_dealer: [
        {
          value: '',
          label: 'All'
        },
        {
          value: '1S',
          label: '1S'
        },
        {
          value: '3S',
          label: '3S'
        }
      ],

      dealer: [],

      select_all: false,

      sort_by:
        ({ prop: 'plate', order: 'descending' },
        { prop: 'engine_on', order: 'descending' },
        { prop: 'engine_off', order: 'descending' },
        { prop: 'hour', order: 'descending' },
        { prop: 'dealer_status', order: 'descending' },
        { prop: 'test_date', order: 'descending' },
        { prop: 'drive_mileage', order: 'descending' },
        { prop: 'start_address', order: 'descending' },
        { prop: 'end_address', order: 'descending' }),

      filename: 'Test Drive Report',
      autoWidth: true,
      bookType: 'xlsx'
    }
  },

  computed: {
    n_page() {
      return Math.ceil(this.row_total / this.per_page)
    },

    dateOption() {
      return this.filter.dateOption ? this.filter.dateOption.value : ''
    },

    showOption() {
      return this.filter.showOption ? this.filter.showOption.value : ''
    }
  },

  watch: {
    page() {
      this.initTable()
    },

    per_page() {
      if (this.page != 1) this.page = 1
      else this.initTable()
    },
    dateOption() {
      let today = new Date()
      let yesterday = new Date(today)

      yesterday.setDate(yesterday.getDate() - 1)
      today = this.formatDate(today.toDateString())
      yesterday = this.formatDate(yesterday.toDateString())

      this.disableDate = true
      // if (this.dateOption == 'today') {
      //   this.filter.start_time = this.today + ' 00:00'
      //   this.filter.end_time = this.today + ' 23:59'
      //   this.maxDate = this.today + ' 23:59'
      // } else

      if (this.dateOption == 'yesterday') {
        this.filter.start_time = this.yesterday + ' 00:00'
        this.filter.end_time = this.yesterday + ' 23:59'
        this.maxDate = this.yesterday + ' 23:59'
      } else {
        this.filter.start_time = ''
        this.filter.end_time = ''
        this.maxDate = this.yesterday + ' 23:59'
        // this.maxDate = this.twoDaysAgo + ' 23:59'
        this.disableDate = false
      }
    },

    showOption() {
      if (this.showOption == 'min_time') {
        this.enableShow = 'min_time'
        this.filter.min_mileage = null
      } else {
        this.enableShow = 'min_mileage'
        this.filter.min_time = null
      }
    },

    select_all(val) {
      this.select_all = val
    }
  },

  created() {
    let today = new Date()
    let yesterday = new Date(today)
    let twoDaysAgo = new Date(today)

    yesterday.setDate(yesterday.getDate() - 1)
    twoDaysAgo.setDate(twoDaysAgo.getDate() - 2)

    this.today = this.formatDate(today.toDateString())
    this.yesterday = this.formatDate(yesterday.toDateString())
    this.twoDaysAgo = this.formatDate(twoDaysAgo.toDateString())

    this.token =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''

    this.$http
      .get(`${this.$api.endpoint}/user/profile`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      })
      .then((res) => {
        this.actor = res.data.message.data
        this.searchDevice('')
      })
      .catch((error) => {
        this.$gf.httpErrorHandler(error)
      })
  },

  mounted() {},

  methods: {
    indexMethod(index) {
      return (this.page - 1) * this.per_page + (index + 1)
    },

    updatePerPage(n) {
      this.per_page = n
    },

    formatDate(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day

      return [year, month, day].join('-')
    },

    searchDevice(keyword) {
      if (this.actor.privilege >= 4) {
        this.getDataDevice(keyword)
      } else {
        if (keyword.length >= 3) {
          this.getDataDevice(keyword)
        } else {
          this.deviceList = []
        }
      }
    },

    getDataDevice(keyword) {
      this.$http
        .get(
          `${this.$api.endpoint}/tracking/search?keyword=${keyword}&type=vehicle`,
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.deviceList = res.data.message.data
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    initTable() {
      this.data = []
      this.loading = true
      this.$http
        .get(`${this.$api.endpoint}/report/test_drive_report`, {
          params: {
            page: this.page,
            per_page: this.per_page,
            device: this.select_all
              ? 'all'
              : this.filter.device
              ? this.filter.device.value
              : '',
            start: `${this.filter.start_time}:00`,
            end: `${this.filter.end_time}:00`,
            min_time: this.filter.min_time ? this.filter.min_time * 60 : '',
            min_mileage: this.filter.min_mileage
              ? this.filter.min_mileage * 1000
              : 0,
            dealer_status: this.dealer ? this.dealer.value : ''
          },

          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.loading = false
          this.$vs.loading.close(`#searchBtn > .con-vs-loading`)

          this.row_total = res.data.message.total
          this.data = res.data.message.data

          this.data.map((item, index) => {
            this.data[index].no = index + 1
            this.data[index].hour = this.secondsToHms(item.hour)
            this.data[index].drive_mileage =
              (item.drive_mileage / 1000)
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' Km'
          })

          this.getStartAddress()
          this.getEndAddress()

          // if (item.start_lon === '' || item.start_lat === '') {
          //   this.getStartAddress()
          // }

          // if (item.end_lon === '' || item.end_lat === '') {
          //   this.getEndAddress()
          // }
        })
        .catch((error) => {
          this.$vs.loading.close(`#searchBtn > .con-vs-loading`)
          this.loading = false
          this.$gf.httpErrorHandler(error)
        })
    },

    search() {
      this.loading = true
      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: '#searchBtn',
        scale: 0.45
      })

      this.filtered.device = this.filter.device
      this.filtered.start_time = this.filter.start_time
      this.filtered.end_time = this.filter.end_time
      this.filtered.min_time = this.filter.min_time
      this.filtered.min_mileage = this.filter.min_mileage

      this.page = 1
      this.initTable()
    },

    exportReport() {
      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: '#exportBtn',
        scale: 0.45
      })

      this.$http
        .get(`${this.$api.endpoint}/report/export_test_drive_report`, {
          responseType: 'blob',
          params: {
            imei: this.select_all
              ? 'all'
              : this.filter.device
              ? this.filter.device.value
              : '',
            start: `${this.filtered.start_time}:00`,
            end: `${this.filtered.end_time}:00`,
            min_time: this.filter.min_time ? this.filter.min_time * 60 : '',
            min_mileage: this.filter.min_mileage
              ? this.filter.min_mileage * 1000
              : 0,
            dealer_status: this.dealer ? this.dealer.value : ''
          },

          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.$vs.loading.close(`#exportBtn > .con-vs-loading`)

          let filename = `test_drive_report_${
            this.select_all ? 'all_vehicle' : this.filtered.device.value
          }_${this.filtered.start_time
            .toString()
            .substr(0, 10)}_${this.filtered.end_time
            .toString()
            .substr(0, 10)}.xlsx`
          FileDownload(res.data, filename)
        })
        .catch((error) => {
          this.$vs.loading.close(`#exportBtn > .con-vs-loading`)
          this.$gf.httpErrorHandler(error)
        })
    },

    getStartAddress() {
      this.data.map((item, index) => {
        // if (!item.address) {
        if (item.start_lat) {
          setTimeout(() => {
            this.$http
              .get(`${this.$api.base_url}/api/address`, {
                params: {
                  latitude: item.start_lat,
                  longitude: item.start_lon
                }
              })
              .then((res) => {
                this.data[index].start_address = res.data.message
              })
          }, index * 300)
        }
        // }
      })
    },

    getEndAddress() {
      this.data.map((item, index) => {
        // if (!item.address) {
        if (item.end_lat) {
          setTimeout(() => {
            this.$http
              .get(`${this.$api.base_url}/api/address`, {
                params: {
                  latitude: item.end_lat,
                  longitude: item.end_lon
                }
              })
              .then((res) => {
                this.data[index].end_address = res.data.message
              })
          }, index * 300)
        }
        // }
      })
    },

    getAddress2(item, index, param) {
      let lat
      let lon

      if (param == 'start_address') {
        lat = item.start_lat
        lon = item.start_lon
      } else {
        lat = item.end_lat
        lon = item.end_lon
      }

      this.$http
        .get(`${this.$api.base_url}/api/address`, {
          params: {
            latitude: lat,
            longitude: lon
          }
        })
        .then((res) => {
          this.data[index][param] = res.data.message
        })
    },

    secondsToHms(seconds) {
      // second = 172800
      seconds = Number(seconds)

      let days = seconds > 86400 ? Math.floor(seconds / 86400) : 0
      seconds = days > 0 ? seconds - days * 86400 : seconds

      let hour = Math.floor(seconds / 3600)
      let minute = Math.floor((seconds % 3600) / 60)
      let sec = Math.floor((seconds % 3600) % 60)

      let dDisplay = days > 0 ? days + (hour > 0 ? ' day(s) ' : ' day(s)') : ''
      let hDisplay = hour > 0 ? hour + (minute > 0 ? ' hr ' : '  hr') : ''
      let mDisplay = minute > 0 ? minute + (sec > 0 ? ' min ' : ' min') : ''
      let sDisplay = sec > 0 ? sec + ' sec' : ''
      return dDisplay + hDisplay + mDisplay + sDisplay
    },

    handleDownload() {
      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: '#exportBtn',
        scale: 0.45
      })

      import('@/vendor/Export2Excel').then((excel) => {
        const tHeader = [
          'No',
          'Plate',
          'Engine On',
          'Engine Off',
          'Hours',
          'Dealer Status)',
          'Test Date',
          'Drive Mileage',
          'Start Address',
          'End Address'
        ]
        const filterVal = [
          'no',
          'plate',
          'engine_on',
          'engine_off',
          'hour',
          'dealer_status',
          'test_date',
          'drive_mileage',
          'start_address',
          'end_address'
        ]

        const list = this.data
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: this.filename,
          autoWidth: this.autoWidth,
          bookType: this.bookType
        })
        this.$vs.loading.close(`#exportBtn > .con-vs-loading`)
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          if (j === 'timestamp') {
            return parseTime(v[j])
          } else {
            return v[j]
          }
        })
      )
    }
  }
}
</script>
